<template>
  <div v-loading="loading" class="merchant-score">
    <div class="score-content">
      <div class="score-row">
        <!-- 24小时发货率表格 -->
        <div class="score-table">
          <h3>近7天24小时发货率</h3>
          <el-table
            :data="deliveryRateData"
            :border="false"
            :show-header="false"
          >
            <el-table-column
              label="评分百分比"
              prop="scoreRange"
              min-width="260"
            />
            <el-table-column label="24h发货率" width="190" align="right">
              <template #default="scope">
                <span style="margin-right: 10px">24H发货率</span>
                <el-input-number
                  v-model="scope.row.rate"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rateDisabled"
                  @change="handleRangeChange($event, scope.row, 'rate')"
                />
              </template>
            </el-table-column>
            <el-table-column label="至" prop="to" width="50" align="center" />
            <el-table-column label="范围值" width="100" align="right">
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.range"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rangeDisabled"
                  @change="handleRangeChange($event, scope.row, 'range')"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="层级"
              prop="level"
              width="60"
              align="right"
            />
          </el-table>
        </div>

        <!-- 近15天配货率表格 -->
        <div class="score-table">
          <h3>近15天配货率</h3>
          <el-table
            :data="distributionRateData"
            :border="false"
            :show-header="false"
          >
            <el-table-column
              label="评分百分比"
              prop="scoreRange"
              min-width="260"
            />
            <el-table-column label="近15天配货率" width="200" align="right">
              <template #default="scope">
                <span style="margin-right: 10px">近15天发货率</span>
                <el-input-number
                  v-model="scope.row.rate"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rateDisabled"
                  @change="handleRangeChange($event, scope.row, 'rate')"
                />
              </template>
            </el-table-column>
            <el-table-column label="至" prop="to" width="50" align="center" />
            <el-table-column label="范围值" width="100" align="right">
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.range"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rangeDisabled"
                  @change="handleRangeChange($event, scope.row, 'range')"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="层级"
              prop="level"
              width="60"
              align="right"
            />
          </el-table>
        </div>
      </div>

      <div class="score-row">
        <!-- 次品率表格 -->
        <div class="score-table">
          <h3>次品率</h3>
          <el-table :data="defectRateData" :border="false" :show-header="false">
            <el-table-column
              label="评分百分比"
              prop="scoreRange"
              min-width="260"
            />
            <el-table-column label="次品率" width="160" align="right">
              <template #default="scope">
                <span style="margin-right: 10px">次品率</span>
                <el-input-number
                  v-model="scope.row.rate"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rateDisabled"
                  @change="handleRangeChange($event, scope.row, 'rate')"
                />
              </template>
            </el-table-column>
            <el-table-column label="至" prop="to" width="50" align="center" />
            <el-table-column label="范围值" width="100" align="right">
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.range"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rangeDisabled"
                  @change="handleRangeChange($event, scope.row, 'range')"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="层级"
              prop="level"
              width="60"
              align="right"
            />
          </el-table>
        </div>

        <!-- 退货率表格 -->
        <div class="score-table">
          <h3>退货率</h3>
          <el-table :data="returnRateData" :border="false" :show-header="false">
            <el-table-column
              label="评分百分比"
              prop="scoreRange"
              min-width="260"
            />
            <el-table-column label="退货率" width="160" align="right">
              <template #default="scope">
                <span style="margin-right: 10px">退货率</span>
                <el-input-number
                  v-model="scope.row.rate"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rateDisabled"
                  @change="handleRangeChange($event, scope.row, 'rate')"
                />
              </template>
            </el-table-column>
            <el-table-column label="至" prop="to" width="50" align="center" />
            <el-table-column label="范围值" width="100" align="right">
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.range"
                  :min="0"
                  :max="100"
                  size="small"
                  :controls="false"
                  :precision="0"
                  :disabled="scope.row.rangeDisabled"
                  @change="handleRangeChange($event, scope.row, 'range')"
                />
              </template>
            </el-table-column>
            <el-table-column
              label="层级"
              prop="level"
              width="60"
              align="right"
            />
          </el-table>
        </div>
      </div>
    </div>

    <div class="score-button-group">
      <el-button type="primary" @click="handleImportBonus"
        >导入加分商家名单</el-button
      >
      <p>
        导入格式：A列=商家ID，B列=加分值，最多5分， 最多允许填写一位小数，如4.5
      </p>
    </div>

    <div class="score-button-group">
      <el-button type="success" @click="handleExportBonus"
        >导出加分商家名单</el-button
      >
      <p>导入格式：A列=商家ID</p>
    </div>

    <div class="score-button-group">
      <el-button type="danger" @click="handleImportCancelBonus"
        >导入解除加分名单</el-button
      >
      <p>导入格式：A列=商家ID，导入后将即刻解除这些<br />商家的加分权益</p>
    </div>

    <el-button @click="handleShowLog">日志</el-button>

    <div style="margin-top: 20px; text-align: center">
      <el-button type="success" style="width: 100px" @click="handleSubmit"
        >确定</el-button
      >
    </div>

    <!-- 添加隐藏的文件上传输入框 -->
    <input
      ref="fileInput"
      type="file"
      accept=".xlsx,.xls,.csv"
      style="display: none"
      :data-type="uploadType"
      @change="handleFileChange"
    />

    <el-dialog
      title="服务分配置修改日志"
      :visible.sync="logDialogVisible"
      width="800px"
      custom-class="service-log-dialog"
    >
      <el-table :data="logData" border stripe height="500px">
        <el-table-column label="事件" prop="action_type" />
        <el-table-column label="内容" prop="action_ext" width="300">
          <template #default="scope">
            <span
              v-if="scope.row.action_type === '更新指标数据'"
              v-html="scope.row.action_ext"
            />
            <span
              v-else
              style="color: #409eff; cursor: pointer"
              @click="handleDownload(scope.row.action_ext)"
              v-html="scope.row.action_ext"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="action_admin" width="120" />
        <el-table-column label="操作时机" prop="create_time" width="180" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  postGetSupplyServiceConfig,
  postSaveSupplyServiceConfig,
  postExportBonusPointsSupply,
  postGetSupplyServiceConfigLog,
} from "@/openapi/erp/supply.js";
import { downloadByUrl } from "@/utils/export.js";

export default {
  name: "MerchantScore",
  data() {
    return {
      deliveryRateData: [], // 24小时发货率数据
      distributionRateData: [], // 配货率数据
      defectRateData: [], // 次品率数据
      returnRateData: [], // 退货率数据
      modifiedRanges: {}, // 修改记录
      loading: false, // 加载状态
      uploadType: "", // 新增上传类型
      tableConfig: {
        // 统一表格配置
        deliveryRate: {
          title: "近7天24小时发货率",
          prop: "last_seven_day_twenty_four_hour_delivery_rate",
        },
        distributionRate: {
          title: "近15天配货率",
          prop: "last_fifteen_distribution_rate",
        },
        defectRate: {
          title: "次品率",
          prop: "defective_product_rate",
        },
        returnRate: {
          title: "退货率",
          prop: "return_rate",
        },
      },
      logDialogVisible: false,
      logData: [],
    };
  },

  created() {
    this.fetchServiceConfig();
  },

  methods: {
    // 获取评分范围标签
    getScoreRangeLabel(level) {
      const ranges = {
        1: "评分百分比90%-100%（即4.5-5分）",
        2: "评分百分比80%-90%（即4-4.5分）",
        3: "评分百分比60%-80%（即3-4分）",
        4: "评分百分比30%-60%（即1.5-3分）",
        5: "评分百分比0%-30%（即0-1.5分）",
      };
      return ranges[level] || undefined;
    },

    // 获取次品率范围标签
    getDefectRateRangeLabel(level) {
      const ranges = {
        1: "评分百分比30%-0%（即1.5-0分）",
        2: "评分百分比60%-30%（即3-1.5分）",
        3: "评分百分比80%-60%（即4-3分）",
        4: "评分百分比90%-80%（即4.5-4分）",
        5: "评分百分比100%-90%（即5-4.5分）",
      };
      return ranges[level] || undefined;
    },

    // 处理输入值变化
    handleRangeChange(value, row, field) {
      // 空值校验并提示
      if (value === null || value === undefined || value === "") {
        this.$message.warning("输入值不能为空");
        return;
      }

      // 存储修改的值
      const key = `${row.scoreRange}-${row.level}-${field}`;
      this.modifiedRanges[key] = value;

      // 更新相邻行的值
      this.updateAdjacentRows(row, field, value);
    },

    // 更新相邻行的值
    updateAdjacentRows(currentRow, field, value) {
      const tables = {
        deliveryRateData: this.deliveryRateData,
        distributionRateData: this.distributionRateData,
        defectRateData: this.defectRateData,
        returnRateData: this.returnRateData,
      };

      // 找到当前行所在的表格数据
      let currentTable;
      let currentIndex;
      for (const [tableName, tableData] of Object.entries(tables)) {
        currentIndex = tableData.findIndex((row) => row === currentRow);
        if (currentIndex !== -1) {
          currentTable = tableData;
          break;
        }
      }

      if (!currentTable || currentIndex === -1) return;

      const currentLevel = parseInt(currentRow.level.replace("层级", ""));

      if (field === "rate") {
        // 如果修改的是rate，则更新下一级的range
        const nextRow = currentTable.find(
          (row) => parseInt(row.level.replace("层级", "")) === currentLevel + 1
        );
        if (nextRow) {
          nextRow.range = value;
          const key = `${nextRow.scoreRange}-${nextRow.level}-range`;
          this.modifiedRanges[key] = value;
        }
      }
    },

    // 检查是否有空值
    checkEmptyValues() {
      const tables = {
        "24小时发货率": this.deliveryRateData,
        配货率: this.distributionRateData,
        次品率: this.defectRateData,
        退货率: this.returnRateData,
      };

      for (const [tableName, data] of Object.entries(tables)) {
        for (const row of data) {
          // 跳过禁用的输入框
          if (
            !row.rateDisabled &&
            (row.rate === "" || row.rate === null || row.rate === undefined)
          ) {
            this.$message.error(`${tableName}中存在空值，请填写完整`);
            return true;
          }
        }
      }
      return false;
    },

    // 格式化提交数据
    formatSubmitData(data) {
      return data.map((item) => {
        const level = parseInt(item.level.replace("层级", ""));
        let start =
          item.rate === "" || item.rate === undefined
            ? null
            : parseFloat(item.rate);
        let end =
          item.range === "" || item.range === undefined
            ? null
            : parseFloat(item.range);

        // level 5的start默认为0
        if (level === 5 && !start) {
          start = 0;
        }

        // level 1的end默认为100
        if (level === 1 && !end) {
          end = 100;
        }

        return {
          level,
          start,
          end,
        };
      });
    },

    // 获取服务分配置
    async fetchServiceConfig() {
      try {
        this.loading = true;

        let res = await postGetSupplyServiceConfig();

        if (!res || Object.keys(res).length === 0) {
          // 定义默认配置模板
          const defaultConfig = {
            level: 1,
            start: "",
            end: "",
          };

          // 生成5个层级的配置
          const generateLevelConfigs = () => {
            return Array.from({ length: 5 }, (_, index) => ({
              ...defaultConfig,
              level: index + 1,
              start: index + 1 === 5 ? "0" : "", // 第5层级start默认为0
              end: index + 1 === 1 ? "100" : "", // 第1层级end默认为100
            }));
          };

          // 设置默认配置
          res = {
            last_seven_day_twenty_four_hour_delivery_rate:
              generateLevelConfigs(),
            last_fifteen_distribution_rate: generateLevelConfigs(),
            defective_product_rate: generateLevelConfigs(),
            return_rate: generateLevelConfigs(),
          };
        }
        if (res) {
          // 处理24小时发货率数据
          this.deliveryRateData = this.formatResponseData(
            res.last_seven_day_twenty_four_hour_delivery_rate,
            "deliveryRate"
          );

          // 处理配货率数据
          this.distributionRateData = this.formatResponseData(
            res.last_fifteen_distribution_rate,
            "distributionRate"
          );

          // 处理次品率数据
          this.defectRateData = this.formatResponseData(
            res.defective_product_rate || [],
            "defectRate"
          );

          // 处理退货率数据
          this.returnRateData = this.formatResponseData(
            res.return_rate || [],
            "returnRate"
          );

          // 清空修改记录
          this.modifiedRanges = {};
        }
      } catch (error) {
        this.$message.error(`获取服务分配置失败：${error.message}`);
      } finally {
        this.loading = false;
      }
    },

    // 格式化响应数据
    formatResponseData(data, type) {
      return data.map((item) => {
        // level 5的start默认为0
        if (item.level === 5 && !item.start) {
          item.start = 0;
        }

        // level 1的end默认为100
        if (item.level === 1 && !item.end) {
          item.end = 100;
        }

        return {
          scoreRange:
            type === "defectRate" || type === "returnRate"
              ? this.getDefectRateRangeLabel(item.level)
              : this.getScoreRangeLabel(item.level),
          rate: item.start || "",
          to: "至",
          range: item.end || "",
          level: `层级${item.level}`,
          rateDisabled: item.level === 5,
          rangeDisabled: true,
        };
      });
    },

    // 处理提交
    async handleSubmit() {
      try {
        // 先检查空值
        if (this.checkEmptyValues()) {
          return;
        }

        // 再检查是否有修改
        if (Object.keys(this.modifiedRanges).length === 0) {
          this.$message.info("没有需要提交的修改");
          return;
        }

        // 添加确认弹窗
        await this.$confirm(
          "点击确定后，即刻对商家服务评分生效，确认吗？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        // 构造提交数据
        const submitData = {
          last_seven_day_twenty_four_hour_delivery_rate: this.formatSubmitData(
            this.deliveryRateData
          ),
          last_fifteen_distribution_rate: this.formatSubmitData(
            this.distributionRateData
          ),
          defective_product_rate: this.formatSubmitData(this.defectRateData),
          return_rate: this.formatSubmitData(this.returnRateData),
        };

        await postSaveSupplyServiceConfig(submitData);
        this.$message.success("服务分配置提交成功");
        this.modifiedRanges = {};

        // 重新获取最新配置
        await this.fetchServiceConfig();
      } catch (error) {
        console.log(error);
      }
    },

    // 导入加分商家名单
    handleImportBonus() {
      this.uploadType = "bonus";
      this.$refs.fileInput.click();
    },

    // 导入解除加分名单
    handleImportCancelBonus() {
      this.uploadType = "cancel";
      this.$refs.fileInput.click();
    },

    // 处理文件选择变化
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (!this.validateFile(file)) return;

      try {
        this.loading = true;
        const formData = new FormData();
        formData.append("file", file);

        const url =
          this.uploadType === "cancel"
            ? "/erp/supply/importLiftBonusPointsSupply"
            : "/erp/supply/importBonusPointsSupply";

        const res = await this.$http.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        console.warn(res);
        if (res.data.code === 200) {
          this.$message.success("导入成功");
          await this.fetchServiceConfig();
        } else {
          if (res.data.data.error_file) {
            downloadByUrl(res.data.data.error_file);
          }

          this.$message.error(res.data.msg || "导入失败");
        }
      } catch (error) {
        this.$message.error(`导入失败：${error.message}`);
      } finally {
        this.$refs.fileInput.value = "";
        this.loading = false;
      }
    },

    // 文件验证
    validateFile(file) {
      if (!file) return false;

      const validTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
      ];

      if (!validTypes.includes(file.type)) {
        this.$message.error("请上传Excel文件(.xlsx,.xls,.csv)");
        return false;
      }
      return true;
    },

    // 导出加分商家名单
    async handleExportBonus() {
      try {
        this.loading = true;
        const response = await postExportBonusPointsSupply();
        downloadByUrl(response);
      } catch (error) {
        this.$message.error(`导出失败：${error}`);
      } finally {
        this.loading = false;
      }
    },

    // 显示日志
    async handleShowLog() {
      try {
        this.loading = true;
        const res = await postGetSupplyServiceConfigLog();
        this.logData = res || [];
        this.logDialogVisible = true;
      } catch (error) {
        this.$message.error(`获取日志失败：${error.message}`);
      } finally {
        this.loading = false;
      }
    },

    handleDownload(url) {
      downloadByUrl(url);
    },
  },
};
</script>

<style lang="less" scoped>
.merchant-score {
  padding: 20px;
  background: #fff;

  .score-content {
    display: flex;
    flex-direction: column;

    .score-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 40px;

      .score-table {
        text-align: center;
        width: 48%; // 设置宽度为略小于50%，留出间距
      }
    }
  }
  .score-button-group {
    display: inline-block;
    width: 225px;
    font-size: 10px;
    vertical-align: top;
  }
}

/deep/ .el-table {
  &:before {
    height: 0 !important;
  }

  .el-table__cell {
    border-bottom: none !important;
  }

  .el-input-number {
    width: 80px !important;
  }

  .el-input.is-disabled .el-input__inner {
    color: #606266 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/businessGovernanceManag/merchantServiceScore/index.vue